import { useEffect, useState } from "react";
import withLoader from "../../../../components/layouts/WithLoader";
import { TextField } from "@material-ui/core";
import PurchaseService from "../../../../services/PurchaseOrder";
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";
import FactureNonConfirme from "../../../productPurchase/Table/FactureNonConfirme";

const ListFactureFicheFournisseur = ({ startLoading, stopLoading }) => {
  const [dateBegin, setDateBegin] = useState("any");
  const [dateEnd, setDateEnd] = useState("any");
  const [clientId, setClientId] = useState(localStorage.getItem("idTiers"));
  const [chargedFactureInfo, setChargedFactureInfo] = useState(false);

  const onChangeDateBegin = (event) => {
    setDateBegin(event.target.value.concat(":59"));
  };

  const onChangeDateEnd = (event) => {
    setDateEnd(event.target.value.concat(":59"));
  };
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();

  const [inConfirmedFacture, setInConfirmedFacture] = useState([]);
  const [userRole, setUserRole] = useState("");

  const [caHt, setCaHt] = useState(0);
  const [caTt, setCaTt] = useState(0);
  useEffect(() => {
    if (localStorage.getItem("status") === null) {
      setUserRole(["notConnected"]);
    } else {
      setUserRole(JSON.parse(localStorage.getItem("status")));
    }
    startLoading();
   PurchaseService.getFactureByFilters(
    clientId,
    -1,
      dateBegin,
      dateEnd, 0
    )
      .then((response) => {
        if (response.data.success) {
          setInConfirmedFacture(response.data.success);
          setChargedFactureInfo(true);
           setCaHt(response.data.htc);
            setCaTt(response.data.ttc);
          stopLoading();
        }
      })
      .catch((e) => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur :",e);
      });

   
  }, []);
  const onGetFacturesByFiltersHandler = () => {
    startLoading();
    PurchaseService.getFactureByFilters(
      getCurrentUserId(),
      clientId,
      0,
      dateBegin,
      dateEnd
    )
      .then((response) => {
        if (Object.keys(response.data)[0] === "success") {
          setInConfirmedFacture(response.data.success);
          setChargedFactureInfo(true);
           setCaHt(response.data.caHt);
            setCaTt(response.data.caTt);
          stopLoading();
        }
      })
      .catch((e) => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur :",e);
      });
   
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div class="card card-dark">
            <div class="card-body">
              <h5 class="card-title">
                Les factures d'achat du client{" "}
                <b>{localStorage.getItem("nameTiers")}</b>
              </h5>

            </div>
          </div>
        </div>
      </section>
      <section className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card card-dark">
                <div class="card-body">
                  <div class="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="inputName">Date début</label>
                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          value={dateBegin}
                          onChange={onChangeDateBegin}
                          id="datetime-local"
                          type="datetime-local"
                          defaultValue="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="inputName">Date fin</label>
                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          value={dateEnd}
                          onChange={onChangeDateEnd}
                          id="datetime-local"
                          type="datetime-local"
                          defaultValue="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <div className="col-sm-12  text-center">
                    <button
                      className="btn btn-dark"
                      onClick={onGetFacturesByFiltersHandler}
                    >
                      Valider le choix
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
     
      {chargedFactureInfo && (
        <section className="content ">
            <div className="row">
             {caHt !== null && (
                <div className="col-sm-6 col-12">
                  <div className="info-box bg-gray-dark">
                    <span className="info-box-icon">
                      <i class="fas fa-sack-dollar"></i>
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">HTC</span>
                      <span className="info-box-number">{caHt.toFixed(3)}</span>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "100%" }}
                        />
                      </div>
                      <span className="progress-description"></span>
                    </div>
                  </div>
                </div>
              )}
              {caTt !== null && (
                <div className="col-sm-6 col-12">
                  <div className="info-box bg-gray-dark">
                    <span className="info-box-icon">
                      <i class="fas fa-hand-holding-dollar"></i>{" "}
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">TTC </span>{" "}
                      <span className="info-box-number">{caTt.toFixed(3)}</span>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "100%" }}
                        />
                      </div>
                      <span className="progress-description">
                        {/* 70% Increase in 30 Days */}
                      </span>
                    </div>
                  </div>
                </div>
              )}
              </div>
           <div className="container-fluid">
                      <div className="row mb-2">
                        <div className="col-sm-12">
                          <FactureNonConfirme listFacture={inConfirmedFacture} />
                        </div>
                      </div>
                    </div>
        </section>
      )}
    </div>
  );
};
export default withLoader(ListFactureFicheFournisseur);
